import { createFileRoute } from "@tanstack/react-router";
import { TrendingUp } from "lucide-react";

export const Route = createFileRoute("/(authenticated)/stats/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-6">
      <div className="w-24 h-24 rounded-full bg-default-100 flex items-center justify-center">
        <TrendingUp className="h-8 w-8 text-default-400" />
      </div>
      <div className="text-center space-y-2">
        <h2 className="text-2xl font-semibold text-foreground">
          통계 페이지 준비중
        </h2>
        <p className="text-default-500">
          곧 더 나은 통계 기능으로 찾아뵙겠습니다
        </p>
      </div>
    </div>
  );
}
